import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';

/* function logg(proxy) {
    console.log(JSON.parse(JSON.stringify(proxy)))
} */

const periodTracker = function () {
    return {
		lastPeriod: '',
		periodLength: '',
        fixedPeriodLength: null,
		cycleLength: '',

        showCalendar: false,
        calendarsRendered: false,
        calendarTarget: '.PeriodTrackerCalendar-calendar',

        dates: [],
        calendars: ['', '', ''],
        periods: [],

        periodCal: null,
        legendImg: {
            width: null,
            height: null,
            reference: null
        },
        pdf: {
            width: null,
            height: null,
            reference: null,
            blob: null
        },
        readyToSend: false,
        validEmail: true,
        sendToEmail: '',
        ADJUST_LEGEND_Y: 20,
        isMobile: window.matchMedia('(max-width: 1024px)').matches,

        init() {
            window.matchMedia('(max-width: 1024px)').onchange = function (e) {
                this.isMobile = e.matches;
            }
        },

        calculateCalendars() {
            if(this.lastPeriod && this.periodLength && this.cycleLength) {

                this.startDate = new Date(this.lastPeriod.replace(/-/g, '\/'));
                this.fixedPeriodLength = (this.periodLength - 1) ? this.periodLength - 1 : 1;

                for(var x = 0; x < 3; x++) {
                    // this.startDate.setDate(this.startDate.getDate() + parseInt(x * parseInt(this.cycleLength)));
                    var calendar_start_date = new Date(this.startDate);
                    var cycle_start_date = new Date(this.startDate);
                    
                    if(x == 0) {
                        calendar_start_date.setDate(1)
                    } else if(x != 0) {
                        cycle_start_date.setDate(cycle_start_date.getDate() + parseInt(x * this.cycleLength));
                        calendar_start_date.setMonth(calendar_start_date.getMonth() + parseInt(x), 1);
                    }

                    var cycle_end_date = new Date(cycle_start_date.getFullYear(),cycle_start_date.getMonth(), (cycle_start_date.getDate() + parseInt(this.cycleLength - 1)))

                    var pre_period_start = new Date(cycle_start_date);
                    pre_period_start.setDate(pre_period_start.getDate() - 2);

                    var pre_period_end   = new Date(pre_period_start);
                    pre_period_end.setDate(pre_period_start.getDate() + 1);

                    var ovulation_start = new Date( cycle_start_date.getFullYear(), cycle_start_date.getMonth(), (cycle_start_date.getDate() + 10) );
                    var ovulation_end   = new Date( ovulation_start.getFullYear(), ovulation_start.getMonth(), ovulation_start.getDate() + 4);
                    // var ovulation_end = new Date( cycle_end_date.getFullYear(), cycle_end_date.getMonth(), (cycle_start_date.getDate() + TEST_OVULATION_LENGTH_ADJUST) );
                    // var ovulation_start = new Date( ovulation_end.getFullYear(), ovulation_end.getMonth(), (ovulation_end.getDate() - 4) );

                    this.dates[x] = {
                        start: calendar_start_date,

                        cycle: {
                            start: cycle_start_date,
                            end: cycle_end_date
                        },

                        prePeriod: {
                            start: pre_period_start,
                            end: pre_period_end,
                        },

                        period: {
                            start: cycle_start_date,
                            end: new Date(cycle_start_date.getFullYear(),cycle_start_date.getMonth(),cycle_start_date.getDate() + parseInt(this.fixedPeriodLength))
                        },

                        postPeriod: {
                            start: new Date(cycle_start_date.getFullYear(),cycle_start_date.getMonth(),cycle_start_date.getDate() + parseInt(this.fixedPeriodLength + 1)),
                            end: new Date(cycle_start_date.getFullYear(),cycle_start_date.getMonth(),cycle_start_date.getDate() + parseInt(this.fixedPeriodLength + 2))
                        },

                        ovulation: {
                            start: ovulation_start,
                            end: ovulation_end,
                        }
                    }
                }

                // console.log(this.startDate);
                // logg(this.dates);
                // this.dates.forEach(el => console.log(`el.start: ${el.start}, el.end: ${el.end}`));

                if(!this.calendarsRendered) {
                    this.renderCalendars();
                } else {
                    this.refreshCalendars();
                }
            }

        },

        refreshCalendars() {
            for(var x = 0; x < this.calendars.length; x++) {
                this.calendars[x].clearselect();
                this.calendars[x].set(this.dates[x].start);
            }

            this.renderCalendars();
        },

        renderCalendars() {

            if(!this.calendarsRendered) {

                // console.log(`this.calendars.length: ${this.calendars.length}`);

                for(var x = 0; x < this.calendars.length; x++) {
                    var target = this.calendarTarget;
                    (x != 0) ? target = target + x : target;

                    var tmp = new jsCalendar(target, this.dates[x].start, {
                        navigator: false,
                        firstDayOfTheWeek: 'Sunday'
                    });

                    /* console.log(`this.dates[x].prePeriod`);
                    logg(this.dates[x].prePeriod);
                    console.log(`this.dates[x].prePeriod.start.getMonth(): ${this.dates[x].prePeriod.start.getMonth()}`);
                    console.log(`this.dates[x].start.getMonth(): ${this.dates[x].start.getMonth()}`);         */

                    this.calendars[x] = tmp;
                }

                this.calendarsRendered = true;

            }

            this.updateColors();

            this.showCalendars();
        },

        updateColors() {
            for(var x = 0; x < this.calendars.length; x++) {
                var pre_period_arr = this.createDateArray(this.dates[x].prePeriod.start, this.dates[x].prePeriod.end);
                var period_arr = this.createDateArray(this.dates[x].period.start, this.dates[x].period.end);
                var post_period_arr = this.createDateArray(this.dates[x].postPeriod.start, this.dates[x].postPeriod.end);
                var ovulation_arr = this.createDateArray(this.dates[x].ovulation.start, this.dates[x].ovulation.end);

                this.calendars[x].colorfulSelect(pre_period_arr, 'period-tracker period-tracker--prePeriod');
                this.calendars[x].colorfulSelect(period_arr, 'period-tracker period-tracker--period');
                this.calendars[x].colorfulSelect(ovulation_arr, 'period-tracker period-tracker--ovulation');
                this.calendars[x].colorfulSelect(post_period_arr, 'period-tracker period-tracker--postPeriod');

                if((this.calendars[x - 1]) && this.dates[x].prePeriod.start.getMonth() < this.dates[x].start.getMonth()) {
                    this.calendars[x - 1].colorfulSelect(pre_period_arr, 'period-tracker period-tracker--prePeriod');
                }

                if((this.calendars[x - 1]) && this.dates[x].period.start.getMonth() < this.dates[x].start.getMonth()) {
                    this.calendars[x - 1].colorfulSelect(period_arr, 'period-tracker period-tracker--period');
                }

                if((this.calendars[x - 1]) && this.dates[x].ovulation.start.getMonth() < this.dates[x].start.getMonth()) {
                    this.calendars[x - 1].colorfulSelect(ovulation_arr, 'period-tracker period-tracker--ovulation');
                }

                if((this.calendars[x + 1]) && this.dates[x].ovulation.end.getMonth() > this.dates[x].start.getMonth()) {
                    this.calendars[x + 1].colorfulSelect(ovulation_arr, 'period-tracker period-tracker--ovulation');
                }

                if((this.calendars[x - 1]) && this.dates[x].postPeriod.start.getMonth() < this.dates[x].start.getMonth()) {
                    this.calendars[x - 1].colorfulSelect(post_period_arr, 'period-tracker period-tracker--postPeriod');
                }

                if((this.calendars[x + 1] && this.dates[x + 1]) && this.dates[x].period.end.getMonth() >= this.dates[x + 1].start.getMonth()) {
                    this.calendars[x + 1].colorfulSelect(period_arr, 'period-tracker period-tracker--period');
                    this.calendars[x + 1].colorfulSelect(post_period_arr, 'period-tracker period-tracker--postPeriod');
                }
            }
        },

        createDateArray(start, end) {
            var arr = new Array(), dt = new Date(start);

            while (dt <= end) {
                arr.push(new Date(dt));
                dt.setDate(dt.getDate() + 1);
            }

            return arr;
        },

        showCalendars() {
            this.showCalendar = true;
        },

        printCalendars() {
            var prtContent = document.getElementById("print");
            var WinPrint = window.open('', '', 'left=0,top=0,width=1200,height=600,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(document.querySelector('head').innerHTML + prtContent.innerHTML);
            WinPrint.document.close();

            setTimeout(() => WinPrint.print(), 5000);
        },

        generatePdf() {

            this.validEmail = this.validateEmail(this.sendToEmail);

            if(!this.validEmail) {
                return false;
            }

            /* if(!this.validateEmail(this.sendToEmail)) {
                
                return false;
            } */
            
            this.pdf.reference = new jsPDF({
                orientation: "l",
                unit: 'px',
                hotfixes: ["px_scaling"]
            });

            this.pdf.width = this.pdf.reference.internal.pageSize.getWidth();
            this.pdf.height = this.pdf.reference.internal.pageSize.getHeight();

            var legend_img_el = document.querySelector('.period-color');

            this.legendImg.width  = legend_img_el.scrollWidth;
            this.legendImg.height = legend_img_el.scrollHeight;

            // console.log(`legend_img_el width: ${legend_img_el.scrollWidth}, height: ${legend_img_el.scrollHeight}`)

            html2canvas(legend_img_el, {
                scrollY: -window.scrollY,
                scrollX: -window.scrollX,
                ignoreElements: (element) => {
                    if( element.id == 'wpadminbar' ) {
                        return true;
                    }
                }
            }).then(canvas => {
                this.legendImg.reference = canvas;
                this.legendImg.height = this.pdf.width / (this.legendImg.width / this.legendImg.height);
                this.legendImg.width = this.pdf.width;
                this.processCalendarImage('.PeriodTrackerCalendar-calendar')
                    .then(() => {
                        this.processCalendarImage('.PeriodTrackerCalendar-calendar1', true)
                            .then(() => {
                                this.processCalendarImage('.PeriodTrackerCalendar-calendar2', true)
                                    .then(() => {

                                        // this.readyToSend = true;
                                        // this.pdf.blob = this.pdf.reference.output( 'blob' );
                                      const blob = this.pdf.reference.output( 'blob' );

                                      const formData = new FormData();
                                      formData.append( 'action', 'fibroid_fighters_email_period_tracker_results' );
                                      formData.append( 'security', FF_PT.NONCES.PERIOD_TRACKER_EMAIL_RESULTS );
                                      formData.append( 'data' , blob );
                                      formData.append( 'sendEmail', this.sendToEmail);

                                                                    
                                        for(var pair of formData.entries()) {
                                            console.log(pair[0]+ ', '+ pair[1]);
                                        }

                                      const response = fetch( FF_PT.AJAX_URL, {
                                        method: 'POST',
                                        body: formData
                                      } );

                                      response
                                        .then( result => {
                                            try {
                                                result.json();
                                            } catch (e) {
                                                console.log(e)
                                            }
                                            console.log(result);
                                        } )
                                        .then( json => {
                                        //   this.pdf.reference.save('period-tracker.pdf');
                                        } )
                                        .catch( error => {
                                            console.log(error);
                                        } );

                                    });
                            });
                    });

            });

        },

        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },

        processCalendarImage(selector, addPage = false) {
            var element = document.querySelector(selector);

            var center_x = (this.pdf.width / 2) - (element.scrollWidth / 2);
            var page_quarter = this.pdf.height / 4;
            var adjust_y = page_quarter / 2;

            return html2canvas(element, {
                scrollY: -window.scrollY,
                scrollX: -window.scrollX,
                height: element.scrollHeight,
                width: element.scrollWidth,
                ignoreElements: (element) => {
                    if( element.id == 'wpadminbar' ) {
                        return true;
                    }
                }
            }).then(canvas => {
                if(addPage) {
                    this.pdf.reference.addPage();
                }
                this.pdf.reference.addImage(canvas, center_x, adjust_y, element.scrollWidth, element.scrollHeight);
                this.pdf.reference.addImage(this.legendImg.reference, 0, (this.pdf.height - (this.legendImg.height + this.ADJUST_LEGEND_Y)), this.legendImg.width, this.legendImg.height);
            });
        },
	}
}

$(document).ready(function () {
    // Colorful Select
    jsCalendar.prototype.colorfulSelect = function(dates, color){
        // If no arguments
        if (typeof dates === 'undefined') {
            // Return
            return this;
        }

        // If dates not array
        if (!(dates instanceof Array)) {
            // Lets make it an array
            dates = [dates];
        }

        // Save colors
        this._colorful_saveDates(dates, color);
        // Select dates
        this._selectDates(dates);

        if (!this._colorful_patched) {
            this._colorful_patched = this.refresh;
            this.refresh = function(date) {
                // Call original refresh
                this._colorful_patched(date);
                // Refresh select Colors
                this._colorful_update();
                // Return
                return this;
            };
        }
        // Refresh
        this.refresh();

        // Return
        return this;
    };

    // Save dates colors
    jsCalendar.prototype._colorful_saveDates = function(dates, color) {
        // Copy array instance
        dates = dates.slice();

        // Parse dates
        for (var i = 0; i < dates.length; i++) {
            dates[i] = jsCalendar.tools.parseDate(dates[i]);
            dates[i].setHours(0, 0, 0, 0);
            dates[i] = dates[i].getTime();
        }

        if (typeof this._colorful_colors == "undefined") {
            this._colorful_colors = {};
        }

        // Save each date color
        for (i = dates.length - 1; i >= 0; i--) {
            this._colorful_colors[dates[i]] = color;
        }
    };

    // Refresh colors
    jsCalendar.prototype._colorful_update = function() {
        // Get month info
        var month = this._getVisibleMonth(this._date);

        // Check days
        var timestamp;
        for (var i = month.days.length - 1; i >= 0; i--) {
            // If date is selected
            timestamp = month.days[i].getTime();
            if (this._selected.indexOf(timestamp) >= 0 && this._colorful_colors.hasOwnProperty(timestamp)) {
                this._elements.bodyCols[i].className += ' jsCalendar-selected' + ' ' + this._colorful_colors[timestamp];
            }
        }
    }

});

window.periodTracker = periodTracker;
